import { ApolloQueryResult } from '@apollo/client';
import { SummarySectionV2 } from '@css-xp/base';
import {
  EntitlementDetails,
  LinkedDestinationEntitlement,
  PricingType,
} from '@css-xp/graphtypes/src/generated-types-new';
import { EntitlementBaseProduct } from '@atlassian/cssxp-types-entitlement';
import _isEmpty from 'lodash/isEmpty';
import React from 'react';
import './entitlement-summary-utils.scss';
import { isTrialEntitlement } from './entitlment-summary-utils';
import { EntitlementTemplate, StatuspageTemplate, TrialTemplate } from './template';
import { UpgradeTrialBanner } from './template/sections';

export const EntitlementSummary = ({
  entitlement,
  refetch,
  parentProductEntitlements,
  appCount,
}: {
  entitlement: EntitlementDetails;
  refetch: () => Promise<ApolloQueryResult<unknown>>;
  parentProductEntitlements: LinkedDestinationEntitlement[];
  appCount: number | undefined;
}): JSX.Element | null => {
  if (_isEmpty(entitlement)) {
    return null;
  }

  // Upgrade trial banner needs to be displayed only when current pricingType is PAID.
  const isCurrentOfferingPaid = entitlement.offering?.pricingType === PricingType.PAID;
  const isStatusPage = entitlement.baseProduct === EntitlementBaseProduct.STATUS_PAGE;
  const isTrial = isTrialEntitlement(entitlement, isStatusPage);
  return isTrial ? (
    <SummarySectionV2.SummarySection
      testId="summary"
      className="summary-section-wrapper"
      columns="repeat(auto-fit, minmax(250px, 1fr))"
    >
      <TrialTemplate entitlement={entitlement} linkedEntitlements={parentProductEntitlements as []} refetch={refetch} />
    </SummarySectionV2.SummarySection>
  ) : (
    <>
      <SummarySectionV2.SummarySection
        testId="summary"
        className="summary-section-wrapper"
        columns="repeat(auto-fit, minmax(250px, 1fr))"
      >
        {isStatusPage && <StatuspageTemplate entitlement={entitlement} refetch={refetch} />}
        {!isStatusPage && (
          <EntitlementTemplate
            entitlement={entitlement}
            linkedEntitlements={parentProductEntitlements as []}
            refetch={refetch}
            appCount={appCount}
          />
        )}
      </SummarySectionV2.SummarySection>
      {!isStatusPage && isCurrentOfferingPaid && entitlement.upgradeTrial && (
        <UpgradeTrialBanner
          entitlement={entitlement}
          refetch={refetch}
          linkedEntitlements={parentProductEntitlements as []}
        ></UpgradeTrialBanner>
      )}
    </>
  );
};
